import InfoList from '@/views/info/InfoList.vue'

export default [
    {
        // 贷款资讯列表
        path: '/info/list',
        name: 'InfoList',
        component: InfoList
    },
    {
        // 详情
        path: '/info/detail/:id',
        name: 'InfoDetail',
        component: () => import('@/views/info/InfoDetail')
    }
]
